import React from 'react';
import { useLoaderData, useActionData, useNavigation, useSubmit, Link, redirect } from 'react-router-dom';
import { DESKTOP_PATH, LOGIN_PATH } from '../../constants/paths';
import { COMPLAINT_CASE_FORM_DATA_GET_API, COMPLAINT_CASE_FORM_DATA_BY_HASH_GET_API } from '../../constants/apis';
import { getModel } from '../../utils/functions';
import LoadingIcon from '../../components/loading_icon/loading_icon';
import ConfirmationWindow from '../../components/confirmation_window/confirmation_window';
import './complaint_case_form.scss';

import logo from '../../images/odonto_secure_logo.png';
import odontoSecureText from '../../images/odonto_secure_text.png';


export async function complaintCaseFormLoader({ params }) {
  try {
    if (params.complaint_case_id) {
      return await getModel(COMPLAINT_CASE_FORM_DATA_GET_API.replace('{id}', params.complaint_case_id));
    }
    else if (params.authHash) {
      return await getModel(`${COMPLAINT_CASE_FORM_DATA_BY_HASH_GET_API}${params.authHash}`);
    }

    return redirect(LOGIN_PATH);
  }
  catch(errors) {
    if(errors instanceof Array) {
      for(let error of errors) {
        if(error.code === 209) {
          // Expired user session
          return redirect(LOGIN_PATH);
        }
        else if(error.code === 203) {
          // Not authorized
          if (params.complaint_case_id) {
            return redirect(DESKTOP_PATH);
          }

          return redirect(LOGIN_PATH);
        }
      }
    }

    throw errors;    
  }
};

class ComplaintCaseForm extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      document_associations: [
        ...this.props.document_associations.map((association) => {
          return {...association};
        })
      ],
      errorMessage: this.props.warningMessage,
      currentPage: 1,
      screenWidth: window.innerWidth
    };

    this.pageContainerElement = null;
    this.pageContainerRef = (element) => {
      this.pageContainerElement = element;

      if (element) {
        this.updatePageContainerPosition();
      }
    };
  }

  updatePageContainerPosition() {
    if (this.pageContainerElement) {
      requestAnimationFrame(() => {
        const pageElements = this.pageContainerElement.getElementsByClassName("complaint-case-form__page-wrapper");
        const pageRect = pageElements[0].getBoundingClientRect();
  
        const gap = 0; //((window.innerWidth - pageRect.width) / 2) - (0.15 * pageRect.width);
  
        this.pageContainerElement.style.setProperty('gap', `${gap}px`);
        this.pageContainerElement.style.setProperty('transform', `translateX(${(1 - this.state.currentPage) * (gap + pageRect.width)}px)`);
      });
    }
  }

  async componentDidMount() {
    this.resizeListener = () => this.updateSize();

    window.addEventListener("resize", this.resizeListener);
  }

  componentDidUpdate(prevProps, prevState) {
    if (prevProps.document_associations !== this.props.document_associations) {      
      this.setState({
        document_associations: [
          ...this.props.document_associations.map((association) => {
            return {...association};
          })
        ]
      });
    }
    if (prevState.currentPage !== this.state.currentPage) {
      this.updatePageContainerPosition();
    }
    if (prevProps.warningMessage !== this.props.warningMessage) {
      this.setState({errorMessage: this.props.warningMessage});
    }
  }

  componentWillUnmount() {
    window.removeEventListener("resize", this.resizeListener);
  }

  updateSize() {
    setTimeout(() => {
      this.updatePageContainerPosition();
    }, 400);    
    
    this.setState({
      screenWidth: window.innerWidth
    });
  }

  handleInputChange(event) {
    const target = event.target;
    let value = target.type === 'checkbox' ? target.checked : target.value;
    const name = target.name;

    this.setState({
      [name]: value
    });
  }

  setPage(pageNumber) {
    if ((pageNumber > this.state.document_associations.length + 1) || pageNumber < 1) {
      return;
    }

    this.setState({currentPage: pageNumber});
  }

  allowNextPage() {
    return this.state.currentPage === 1 || this.state.document_associations[this.state.currentPage-2].has_document !== null;
  }

  onSelectResponse(has_document) {
    if (this.isLoading()) {
      return;
    }

    const document_associations = [...this.state.document_associations.map((association) => {return {...association}})];

    document_associations[this.state.currentPage-2].has_document = has_document;

    this.setState({document_associations});

    this.setPage(this.state.currentPage + 1);
  }

  getPageClassModifier(pageNumber) {
    if (this.state.currentPage === pageNumber) {
      return '--selected';
    }
    else if (this.state.currentPage > pageNumber) {
      return '--left';
    }

    return '--right';
  }

  getformPages() {
    const pages = [
      (
        <div 
          key={`complaint_case_form:questino_page:introduction`}
          className="complaint-case-form__page-wrapper"
        >

          <div className={`complaint-case-form__page${this.getPageClassModifier(1)}`}>
            
            <header className="complaint-case-form__header">

              <Link
                className="complaint-case-form__main-link"
                to="/"
              >

                  <img className="complaint-case-form__header__logo-image" src={logo} alt="Logo" />
                  <img className="complaint-case-form__header__text-image" src={odontoSecureText} alt="Odonto Secure" />

              </Link>

              <h1 className="complaint-case-form__header__text">Formulário</h1>

            </header>

            <article className={`complaint-case-form__page__content${this.props.accessByHash ? '' : '--reduced'}`}>

              <h3 className="complaint-case-form__page__content__title">

                Introdução

              </h3>

              <p className="complaint-case-form__page__content__introduction-text">

                Para cada pergunta a seguir, responda se possui ou não o documento mencionado. 
                Caso tenha dúvida de qual documento se trata, atente-se para a descrição 
                apresentada abaixo da pergunta. E se mesmo assim ainda tiver dúvida, não deixe de 
                entrar em contato conosco para que possamos lhe ajudar.

              </p>

            </article>

            <footer className="complaint-case-form__footer">

              <p className="complaint-case-form__footer__text">

                <i className="far fa-copyright"></i>
                {' '}{(new Date()).getFullYear()} | ODONTO SECURE

              </p>

            </footer>

          </div>

          <div
            className={`complaint-case-form__page__loading-screen${(this.isLoading() && this.props.accessByHash) ? '' : '--hidden'}`}
            key="admin_frame:loading_screen"
          >

            <div className="complaint-case-form__page__loading-screen__wrapper">

              <div className="complaint-case-form__page__loading-screen__icon-wrapper">

                <LoadingIcon 
                  className="complaint-case-form__page__loading-screen__icon" 
                  text="Salvando"
                />

              </div>

            </div>  
            
          </div>

        </div>
      ),
      ...this.state.document_associations.map((association, index) => {
      // let pageOffsetPosition = 2 + index - this.state.currentPage;

      // const pageStyle = {transform: `translateX(${100 * pageOffsetPosition}%)`};

      return (
        <div 
          key={`complaint_case_form:questino_page:document:${association.document_id}`}
          className="complaint-case-form__page-wrapper"
        >

          <div className={`complaint-case-form__page${this.getPageClassModifier(index + 2)}`}>
            
            <header className="complaint-case-form__header">

              <Link
                className="complaint-case-form__main-link"
                to="/"
              >

                  <img className="complaint-case-form__header__logo-image" src={logo} alt="Logo" />
                  <img className="complaint-case-form__header__text-image" src={odontoSecureText} alt="Odonto Secure" />

              </Link>

              <h1 className="complaint-case-form__header__text">Pergunta {index + 1}</h1>

            </header>

            <article className={`complaint-case-form__page__content${this.props.accessByHash ? '' : '--reduced'}`}>

              <h3 className="complaint-case-form__page__content__title">

                Possui o documento <span className="complaint-case-form__page__content__title--highlight">{association.document.name}</span>?

              </h3>

              {association.document.description !== null &&
                <p className="complaint-case-form__page__content__description">{association.document.description}</p>
              }

              <div className="complaint-case-form__page__content__response-options">
                
                <button 
                  className="complaint-case-form__page__content__response-button"
                  onClick={() => this.onSelectResponse(false)}
                  disabled={association.has_document !== null && !association.has_document}
                >

                  Não

                </button>
                
                <button 
                  className="complaint-case-form__page__content__response-button"
                  onClick={() => this.onSelectResponse(true)}
                  disabled={association.has_document !== null && association.has_document}
                >

                  Sim

                </button>

              </div>

            </article>

            <footer className="complaint-case-form__footer">

              <p className="complaint-case-form__footer__text">

                <i className="far fa-copyright"></i>
                {' '}{(new Date()).getFullYear()} | ODONTO SECURE

              </p>

            </footer>

            <div
              className={`complaint-case-form__page__loading-screen${(this.isLoading() && this.props.accessByHash) ? '' : '--hidden'}`}
              key="admin_frame:loading_screen"
            >

              <div className="complaint-case-form__page__loading-screen__wrapper">

                <div className="complaint-case-form__page__loading-screen__icon-wrapper">

                  <LoadingIcon 
                    className="complaint-case-form__page__loading-screen__icon" 
                    text="Salvando"
                  />

                </div>

              </div>  
              
            </div>

          </div>

        </div>
      );
    })];

    return pages;
  }

  isLoading() {
    return this.props.navigation.state === "loading" ||
           (this.props.navigation.state === "submitting");
  }

  onSaveForm() {
    let data = {
      document_answers: [
        ...this.state.document_associations.map((association) => {
          return {
            document_id: association.document_id,
            has_document: association.has_document
          };
        })
      ]
    };
    
    this.props.submit(
      {data}, 
      {
        method: this.props.isEdit ? 'PATCH' : 'POST',
        encType: "application/json"
      });
  } 

  getNextButton() {
    if (this.state.currentPage === this.state.document_associations.length + 1) {
      return (
        <button 
          className="complaint-case-form__controls__finish-button"
          onClick={() => this.onSaveForm()}
          disabled={!this.allowNextPage() || this.isLoading()}
        >
  
          {this.isLoading() ? 'Salvando...' : 'Salvar'}
  
        </button>
      );
    }

    return (
      <button 
        className="complaint-case-form__controls__button"
        onClick={() => this.setPage(this.state.currentPage + 1)}
        disabled={!this.allowNextPage() || this.isLoading()}
      >

        {this.state.currentPage === 1 ? 'Iniciar' : 'Próximo'} <i className="fa-solid fa-caret-right"></i>

      </button>
    );
  }

  getContent() {
    if (this.props.result !== null) {
      if (this.props.result.length <= 0) {
        return (
          <h3 className="complaint-case-form__no-data-text">Nenhuma queixa cadastrada!</h3>
        );
      }

      const complaintTypeElements = [];
      const results = [];

      for (const entry of this.props.result) {
        complaintTypeElements.push(
          <div 
            key={`result_table:complaint_type:${entry.complaint_type.name}`}
            className="complaint-case-form__result-table__column__row"
          >

            <p className="complaint-case-form__result-table__column__row__text">{entry.complaint_type.name}</p>

          </div>
        );

        results.push(
          <div 
            key={`result_table:complaint_type:${entry.complaint_type.name}:result`}
            className={`complaint-case-form__result-table__column__row--${entry.result_weight}`}
          >

            <p className="complaint-case-form__result-table__column__row__text">{entry.result_text}</p>

          </div>
        );
      }

      return (
        <div className="complaint-case-form__page--selected" key="resulta_page">
            
          <header className="complaint-case-form__header">

            <Link
              className="complaint-case-form__main-link"
              to="/"
            >

                <img className="complaint-case-form__header__logo-image" src={logo} alt="Logo" />
                <img className="complaint-case-form__header__text-image" src={odontoSecureText} alt="Odonto Secure" />

            </Link>

            <h1 className="complaint-case-form__header__text">Resultado</h1>

          </header>

          <article className={`complaint-case-form__page__content${this.props.accessByHash ? '' : '--reduced'}`}>

            <div className="complaint-case-form__result-table">
            
              <div className="complaint-case-form__result-table__column">

                <div className="complaint-case-form__result-table__column__header">

                  <h3 className="complaint-case-form__result-table__column__header__text">
                    Queixas
                  </h3>

                </div>

                {complaintTypeElements}

              </div>
            
              <div className="complaint-case-form__result-table__column">

                <div className="complaint-case-form__result-table__column__header">

                  <h3 className="complaint-case-form__result-table__column__header__text">
                    Gravidade
                  </h3>

                </div>

                {results}

              </div>

            </div>

          </article>

          <footer className="complaint-case-form__footer">

            <p className="complaint-case-form__footer__text">

              <i className="far fa-copyright"></i>
              {' '}{(new Date()).getFullYear()} | ODONTO SECURE

            </p>

          </footer>

        </div>
      );
    }

    return (
      <>

        <div className="complaint-case-form__pages" ref={this.pageContainerRef}>

          {this.getformPages()}

        </div>

        <aside className="complaint-case-form__controls">

          {this.state.currentPage > 1 ? (
            <button 
              className="complaint-case-form__controls__button"
              onClick={() => this.setPage(this.state.currentPage - 1)}
              disabled={this.isLoading()}
            >

              <i className="fa-solid fa-caret-left"></i> Anterior

            </button>
          ) : (
            <div className="complaint-case-form__controls__button--dummy"></div>
          )}

          <p className="complaint-case-form__controls__text">{this.state.currentPage} de {this.state.document_associations.length + 1}</p>

          {this.getNextButton()}

        </aside>

      </>
    );
  }

  render() {
    return (
      <>
        <ConfirmationWindow
          useErrorIcon={true}
          visible={this.state.errorMessage.length > 0}
          title="Falha ao salvar dados"
          description={this.state.errorMessage}
          hideConfirmButton={true}
          cancelText="Ok"
          onCancel={() => this.setState({errorMessage: ''})}
        />

        <section className={`complaint-case-form${this.props.accessByHash ? '--expanded' : ''}`}>

          <div className="complaint-case-form__wrapper">

            {this.getContent()}

          </div>

        </section>

      </>
    );
  }
};

const WrappedComplaintCaseForm = props => {
  const {document_associations} = useLoaderData();
  const actionData = useActionData();
  const navigation = useNavigation();
  const submit = useSubmit();

  let warningMessage = '';
  let result = null;

  if (actionData) {
    warningMessage = actionData.message || '';
    result = actionData.result || null;
    
    if (result !== null) {
      result.sort((a, b) => a.complaint_type.name.localeCompare(b.complaint_type.name));
    }
  }  
  
  document_associations.sort((a, b) => a.document.name.localeCompare(b.document.name));

  return (
    <ComplaintCaseForm
      navigation={navigation}
      submit={submit}
      document_associations={document_associations}
      warningMessage={warningMessage}
      result={result}
      {...props}
    />
  );
};

export {WrappedComplaintCaseForm as ComplaintCaseForm};
